import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { errMsg } from "@/components/email/EmParts";

const EMPTY = { email: "", first_name: "", last_name: "", telephone: "", tags: "", consent_source: "", consent_evidence: "" };

export default function AddSubscriberDialog({ open, onOpenChange, onCreated }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/email-marketing/subscribers", { ...f, tags: f.tags.split(",").map((t) => t.trim()).filter(Boolean), consent_source: f.consent_source.trim() || null, consent_evidence: f.consent_evidence.trim() || null });
      toast.success("Subscriber added");
      setF(EMPTY); onOpenChange(false); onCreated();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const field = (k, label, props = {}) => (
    <div className="space-y-1"><Label className="text-xs">{label}</Label><Input value={f[k]} onChange={set(k)} data-testid={`em-add-${k}`} {...props} /></div>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="em-add-dialog">
        <DialogHeader><DialogTitle>Add standalone subscriber</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500 -mt-2">For newsletter sign-ups who aren't customers yet. If they become a customer with the same email, the records link automatically.</p>
        <div className="grid sm:grid-cols-2 gap-3">
          <div className="sm:col-span-2">{field("email", "Email *", { type: "email" })}</div>
          {field("first_name", "First name")}{field("last_name", "Last name")}
          {field("telephone", "Telephone")}{field("tags", "Tags (comma separated)")}
          <div className="sm:col-span-2">{field("consent_source", "Consent source (leave blank = no consent)", { placeholder: "e.g. Website newsletter form" })}</div>
          <div className="sm:col-span-2">{field("consent_evidence", "Consent evidence", { placeholder: "e.g. form submission ref, wording shown" })}</div>
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)} data-testid="em-add-cancel">Cancel</Button>
          <Button onClick={save} disabled={busy || !f.email.trim()} data-testid="em-add-save">Add subscriber</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
